import {
  BaseNavigationListItem,
  BaseNavigationListItemProps
} from '../UNSAFE_NavigationListCommon/BaseNavigationListItem';

export type NavigationListItemProps<K extends string | number> = Omit<
  BaseNavigationListItemProps<K>,
  'removeIcon'
>;

export function NavigationListItem<K extends string | number>({
  itemKey,
  label,
  badge,
  metadata,
  severity,
  icon
}: NavigationListItemProps<K>) {
  return (
    <BaseNavigationListItem
      itemKey={itemKey}
      label={label}
      badge={badge}
      metadata={metadata}
      severity={severity}
      icon={icon}
    />
  );
}
